export default "__VITE_ASSET__BxcvTgfd__"